<script setup>
// Disabled changelog button to decouple from external hubs
</script>

<template>
  <div class="hidden" />
</template>
